import React from 'react';

import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';


const CheckGroup = ({
	name,
	label,
	value = {},
	onChange,
	options = [],
	disabled,
}) => {
	const handleChange = ({ target: { name: checkboxName, checked } }) => {
		const newValue = { ...value, [checkboxName]: !!checked };
		onChange({ target: { name, value: newValue } });
	};

	const checkboxes = options.map((option, index) => {
		return (
			<FormControlLabel
				name={option.value}
				control={<Checkbox checked={value[option.value] || option.defaultChecked} disabled={option.disabled} />}
				onChange={handleChange}
				label={option.label}
				key={`${option.value}-${index}`}
			/>
		);
	});

	return (
		<FormControl component="fieldset" sx={{ marginBottom: 2 }} disabled={disabled}>
			<FormLabel component="legend">{label}</FormLabel>
			<FormGroup>
				{checkboxes}
			</FormGroup>
		</FormControl>
	);
};


CheckGroup.type = 'CheckGroup';

CheckGroup.spec = [{
	name: 'CheckGroup',
	key: 'CheckGroup',
	title: 'Multiple choice',
	icon: 'CheckSquare',
	category: 'input',
	translatable: ['label', 'options'],
	fields: [{
		type: 'TextField',
		label: 'Label',
		name: 'label',
	}, {
		type: 'Checkbox',
		label: 'Required?',
		name: 'required',
	}, {
		type: 'repeater',
		label: 'Check Options',
		name: 'options',
		fields: [{
			type: 'TextField',
			name: 'label',
			label: 'option label',
		}, {
			type: 'TextField',
			name: 'value',
			label: 'option value',
		}],
	}],
}];

export default CheckGroup;